// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import Container from './Container'
import ProgramItem from './ProgramItem'
import Image from './Image'
import Cta from './Cta'
import Appear from './Appear'
import SectionTitle from './SectionTitle'

type SpeakerType = {
  id: string,
  name: string,
  description: string,
}

type ProgramItemItemType = {
  key: string,
  description: string,
  speaker: string,
  startTime: string,
  speakers: Array<SpeakerType>,
}

type ProgramItemType = {
  id: string,
  number: number,
  session: string,
  date: string,
  bgColor: string,
  color: string,
  title: string,
  description: string,
  ctaText: string,
  url?: string,
  ctaURL: String,
  items: Array<ProgramItemItemType>,
}

type Props = {
  title: string,
  image: ImageType,
  items: Array<ProgramItemType>,
  item: Array<ProgramItemType>,
}

const Programs = ({ title, image, items, item, ctaText, file }: Props) => {
  console.log('______________ item: ', item)
  return (
    <div className="bg-light-gray">
      <div className="md:hidden">
        <SectionTitle title={title} />
      </div>
      <div className={`${item? 'min-h-860px' : 'h-40vw'} relative`}>
        <Appear>
          <Image image={image} alt="" />
        </Appear>
        <div className="absolute top-0 left-0 right-0 hidden md:block">
          <Container className="w-full py-8 md:flex md:justify-between">
            <div className="text-xl font-black text-black">
              <h2><span aria-hidden="true" className=" text-dark-gray">]</span> {title}</h2>
            </div>
            <Cta ctaText={ctaText} ctaURL={file.file} color="000" isExternalLink />
          </Container>
        </div>
        {item && 
          <div className="bottom-0 left-0 right-0 flex items-center justify-center md:absolute">
            <Container className="w-full">
              <Appear>
                <div className="pb-5 mx-auto overflow-visible md:w-1/2">
                  <ProgramItem {...item} highlight={true} bgColor="bg-yellow" />
                </div>
              </Appear>
            </Container>
          </div>
        }
      </div>
      <Container className="grid grid-cols-1 gap-5 pb-16 md:grid-cols-2">
        {items.map(item => (
          <Appear key={item.id}>
            <ProgramItem {...item} />
          </Appear>
        ))}
      </Container>
    </div>
  )
}

export default Programs
